import type { DatasetsMutatorUpdateDatasetProps } from "./datasets-mutator-update-dataset.type";

import { useUpdate } from "@/hooks/queries";

import { useDatasetsMutatorHandleMutate } from "../datasets-mutator.hook";

export const useDatasetsMutatorUpdateDataset = ({
  mutatorItem,
  invalidateKeys,
}: DatasetsMutatorUpdateDatasetProps) => {
  const { datasetId, variables } = mutatorItem;

  const { mutate, status } = useUpdate("datasets", datasetId, {
    invalidateKeys,
  });

  const updateDataset = () => {
    mutate(variables);
  };

  useDatasetsMutatorHandleMutate({
    mutatorItems: [mutatorItem],
    mutationStatus: status,
    onMutateReady: () => updateDataset(),
  });

  return null;
};
